// 引入需求文件
import { HTTP } from '../../util/axios.js';
import * as response from '../../util/response';
//处理时间的插件
import moment from 'moment';

export default Gray;

function Gray() {
  this.$http = HTTP;
}
//入口函数
Gray.prototype.init = function (id, callBack) {
  this.callBack = callBack || null;
  if (this.setTimeId) {
    this.setTimeId = null;
    clearTimeout(this.setTimeId)
  }
  this.parent = document.getElementById(id);
  var that = this;
  // setTimeout(function() {
  if (that.parent) {
    that.imgs = that.parent.getElementsByTagName('img');
    that.adds = document.getElementsByClassName('add-food');
  }
  that.getTime();
  // }, 300)

}
//获取订餐时间
Gray.prototype.getTime = function () {
  let menuIds = localStorage.getItem('menuId');
  // console.log(window.localStorage.getItem('menuId'))
  window.localStorage
  if (!menuIds) return;
  var data = {
    menuName: window.localStorage.getItem('menuId'),
    pageSize: -1,
    pageNum: 1
  }
  let _this = this;
  this.$http.get('/dinnerTime/queryList', { params: data })
    .then(res => {
      var data = response.data(res, this);
      // data = {
      //   success: false
      // }
      if (data && data.success && data.result) {
        _this.timeContrast(_this.setTime(data))
      } else if (data && !data.success) {
        _this.timeFun(true)
        // console.log('休息')
      }
    })
    .catch(res => {
      // console.log('gray.js' + res)
    })
}
//时间戳对比
Gray.prototype.timeContrast = function (time) {
  //未到订餐时间
  for(var i=0;i<time.timeRange.split(',').length;i++){
    let value = time.timeRange.split(',')[i];
    let startTime = value.split('-')[0];
    let endTime = value.split('-')[1];
    if (time.currentTime < startTime) {
      this.timeFun(true);
      var concat =startTime - time.currentTime;
      var that = this;
      // console.log('未到' + concat / 1000 + 's')
      this.setTimeId = setTimeout(function () {
        that.timeFun(false)
      }, concat)
      //订餐时间
    } else if (time.currentTime >= startTime && time.currentTime <= endTime) {
      this.timeFun(false);
      var concat = endTime - time.currentTime;
      var that = this;
      // console.log('已到',concat/1000+'s')
      this.setTimeId = setTimeout(function () {
        that.timeFun(true)
      }, concat)
      break;
      //超出订餐时间
    } else if (time.currentTime > endTime) {
      // console.log('超出')
      this.timeFun(true);
    }
  }
}
//处理执行函数
Gray.prototype.timeFun = function (flag) {
  if (this.callBack) {
    this.callBack(flag);
  }
  // this.toGray(flag, this.imgs, this.adds);
}
//处理时间戳函数
Gray.prototype.setTime = function (data) {
  let timeRange = data.result.timeRange; //当前时间范围
  let currentTime = data.result.currentDate;// 当前时间
  let tolocal = {
    timeRange,
    currentTime
  };
  return tolocal
}
//拼接时间戳函数
// Gray.prototype.toSeconds = function (time, currentTime) {
//   time = moment(time).format('HH:mm:ss');
//   // currentTime = new Date(currentTime)
//   // var time2 = new Date(currentTime.toString().slice(0, 16) + time).getTime();
//   currentTime = moment(currentTime).format('YYYY/MM/DD');
//   var time2 = new Date(currentTime + ' ' + time).getTime();
//   return time2;
// }
//置灰操作
Gray.prototype.toGray = function (flag, imgs, add) {
  if (flag) {
    // this.parent.classList.add('text-to-gray')
    for (var i = 0; i < add.length; i++) {
      add[i].style.display = "none"
    }
    // for (var i = 0; i < imgs.length; i++) {
    //   imgs[i].style.filter = "grayscale(100%)";
    // }
  } else {
    // this.parent.classList.remove('text-to-gray')
    for (var i = 0; i < add.length; i++) {
      add[i].style.display = "block"
    }
    // for (var i = 0; i < imgs.length; i++) {
    //   imgs[i].style.filter = "";
    // }
  }
}



// WEBPACK FOOTER //
// ./src/components/js/gray.js